import React, { useState, useEffect } from 'react';
import MeetupLocationPicker from './MeetupLocationPicker';
import './PreferredLocationsManager.css';

const PreferredLocationsManager = ({ listingId, onLocationsChanged }) => {
  const [locations, setLocations] = useState([]);
  const [showPicker, setShowPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const API = window.API || require('../utils/api').default;

  useEffect(() => {
    fetchLocations();
  }, [listingId]);

  const fetchLocations = async () => {
    try {
      const res = await API.get(`/locations/listings/${listingId}/preferred`);
      setLocations(res.data.locations || []);
    } catch (err) {
      console.error('Failed to fetch locations:', err);
    }
  };

  const handleAddLocation = (location) => {
    if (locations.length >= 3) {
      setError('Maximum 3 locations allowed');
      return;
    }

    const newLocations = [...locations, location];
    setLocations(newLocations);
    setShowPicker(false);
    saveLocations(newLocations);
  };

  const handleRemoveLocation = (index) => {
    const newLocations = locations.filter((_, i) => i !== index);
    setLocations(newLocations);
    saveLocations(newLocations);
  };

  const saveLocations = async (locs) => {
    setLoading(true);
    setError('');
    try {
      await API.post(`/locations/listings/${listingId}/preferred`, {
        locations: locs
      });
      if (onLocationsChanged) {
        onLocationsChanged(locs);
      }
    } catch (err) {
      setError('Failed to save locations');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="preferred-locations-manager">
      <div className="section-header">
        <h3>📍 Preferred Meetup Locations</h3>
        <p className="hint">Set up to 3 locations where you prefer to meet</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="locations-list">
        {locations.length === 0 ? (
          <div className="empty-state">
            <p>No preferred locations yet</p>
          </div>
        ) : (
          locations.map((loc, idx) => (
            <div key={idx} className="location-item">
              <div className="location-content">
                <div className="location-number">#{idx + 1}</div>
                <div className="location-info">
                  <div className="location-name">{loc.name}</div>
                  <div className="location-address">{loc.address}</div>
                  <div className="location-coords">
                    📍 {parseFloat(loc.lat).toFixed(4)}, {parseFloat(loc.lng).toFixed(4)}
                  </div>
                </div>
              </div>
              <button
                className="btn-remove"
                onClick={() => handleRemoveLocation(idx)}
                disabled={loading}
              >
                ✕
              </button>
            </div>
          ))
        )}
      </div>

      {locations.length < 3 && (
        <button
          className="btn btn-primary"
          onClick={() => setShowPicker(true)}
          disabled={loading || showPicker}
        >
          + Add Location {locations.length > 0 ? `(${locations.length}/3)` : ''}
        </button>
      )}

      {showPicker && (
        <div className="picker-modal-overlay">
          <div className="picker-modal">
            <div className="picker-header">
              <h3>Add Preferred Meetup Location</h3>
              <button
                className="close-btn"
                onClick={() => setShowPicker(false)}
              >
                ✕
              </button>
            </div>
            <MeetupLocationPicker
              onSelect={handleAddLocation}
              initialLocation={null}
              listingLocation={null}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PreferredLocationsManager;
